import React from "react";
import { Resource } from "react-admin";
import { Route } from "react-router-dom";
import { deviationsResource } from "resources/deviations";

import { deviationsRoutes } from "../../resources/deviations/deviations_routes";
import { MobileAppPage } from "../../pages/mobile-app";
import { commonEntitiesResource } from "../../resources/entities/";
import { inventoryListResource } from "../../resources/inventory-list";
import Messages from "../../resources/messages/List/List";
import { commonOrdersResourceData, ordersResource } from "../../resources/orders/";
import { OrdersMultipleChangesPage } from "../../resources/orders/MultipleChanges2";
import { pricelistArticlesResource } from "../../resources/pricelist-articles/";
import { pricelistHolidaysResource } from "../../resources/pricelist-holidays/";
import { tasksResource } from "../../resources/tasks/";
import { terminalSettingPerDateResource } from "../../resources/terminal-setting-per-date";
import { authenticatedResources } from "./authenticated";

export const osfcEmployeeResources = [
	<Resource name="orders" {...ordersResource} />,
	<Resource name="draft-orders" {...commonOrdersResourceData} />,
	<Resource {...deviationsResource} name="deviations" />,
	<Resource name="tasks" {...tasksResource} create={null} />,
	<Resource name="entities" {...commonEntitiesResource} />,
	// TODO: try to develop some StaticResource that fetch data locally or if data data doesn't change often
	<Resource name="ports" intent="registration" />,
	<Resource name="areas" intent="registration" />,
	<Resource name="users" intent="registration" />,
	<Resource name="customer-companies" intent="registration" />,
	<Resource name="order-statuses" intent="registration" />,
	<Resource name="task-statuses" intent="registration" />,
	<Resource name="deviation-statuses" intent="registration" />,
	<Resource name="task-history" intent="registration" />,
	<Resource name="entity-history" intent="registration" />,
	<Resource name="cooler-types" intent="registration" />,
	<Resource name="order-status" intent="registration" />,
	<Resource name="outgoing-doc-statuses" intent="registration" />,
	<Resource
		name="order-pricelist"
		intent="registration"
		options={{ hasAdd: true, hasEdit: true }}
	/>,
	<Resource name="drivers" intent="registration" />,
	<Resource name="transporters" intent="registration" />,
	<Resource name="trucks" intent="registration" />,
	<Resource name="trailers" intent="registration" />,
	<Resource name="terminal" intent="registration" />,
	<Resource name="external-terminal-links" intent="registration" />,

	<Resource {...pricelistArticlesResource} name="pricelist-articles" />,
	<Resource {...pricelistHolidaysResource} name="pricelist-holidays" />,
	<Resource name="pricelist-special-price" intent="registration" />,
	<Resource name="pricelist-articles-autocomplete" intent="registration" />,
	<Resource name="company-users" intent="registration" />,
	<Resource name="commodities" intent="registration" />,
	<Resource name="rank-priorities" intent="registration" />,
	<Resource name="product-articles" intent="registration" />,
	<Resource name="order-product-articles" intent="registration" />,
	<Resource name="pallets-and-boxes" intent="registration" />,
	<Resource name="pallets" intent="registration" />,
	<Resource name="storage-places-lookup" intent="registration" />,
	<Resource name="mappers" intent="registration" />,
	<Resource name="product-numbers" intent="registration" />,
	<Resource name="product-names" intent="registration" />,
	<Resource name="automatic-pallets-reservation" intent="registration" />,
	<Resource name="storage-inventorization-statuses" intent="registration" />,
	<Resource name="inventory-list" {...inventoryListResource} />,
	<Resource
		name="terminal-setting-per-date"
		{...terminalSettingPerDateResource}
		create={null}
		edit={null}
	/>,
	...authenticatedResources,
];

export const osfcEmployeeRoutes = [
	...Object.values(deviationsRoutes),
	<Route exact path="/messages" component={Messages} />,
	<Route exact path="/orders/multiple-changes" component={OrdersMultipleChangesPage} />,
	<Route exact path="/mobile-app" component={MobileAppPage} />,
];
